module.exports = __webpack_public_path__ + "static/assets/13edf52dd5c31d5adbecedb8b418de92.jpg";